import { useTranslation } from 'react-i18next';
import home from '../assets/images/home.png';


const Home = () => {
  const { t } = useTranslation();
  return (
    <section className='bg-home home-padding'>
      <div className='container'>
				<div className='row home d-flex align-items-center justify-content-between'>
					<div className='col-lg-6 quote'>
						<p className='fs-1'> {t('home.quote')}</p>
						<p className='fs-5'>
							<span className='fw-bold'> {t('home.authorName')}</span>
						{t('home.authorWork')}</p>
					</div>
					<img className='homeImg col-lg-6' src={home} alt='home Image' />
			 </div>
			</div>
    </section>
  )
}

export default Home